// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VxkZ","error":"styles_error__RF00k","success":"styles_success__25tgT"};